var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button skill",class:_vm.currentClass,domProps:{"innerHTML":_vm._s(_vm.skill.display)},on:{"mouseover":_vm.mouseoverSkill,"mouseout":_vm.mouseoutSkill,"click":_vm.clickSkill}})}
var staticRenderFns = []

export { render, staticRenderFns }